import { useMutation } from '@tanstack/react-query'

import { TChat } from '~/features/chatbot/models'
import { shouldActivateButton } from '~/features/chatbot/utils'
import { EServerPath } from '~/models/api'
import { EMessageSpeaker } from '~/models/features'
import HttpService from '~/services/http'
import { store } from '~/store'

type TParams = {
  agentId: string
  conversationId?: string
  message: string
}

const useChat = () => {
  const [setChatbot, chatbot] = store((state) => [
    state.setChatbot,
    state.chatbot,
  ])
  return useMutation({
    mutationFn: (params: TParams) =>
      HttpService.post<TChat>({
        path: EServerPath.chat,
        payload: params,
      }),
    onMutate(variables) {
      setChatbot({
        messages: chatbot.messages.concat({
          speaker: EMessageSpeaker.user,
          message: variables.message,
        }),
      })
    },
    onSuccess: (response) => {
      const aiResponse = response.data?.aiResponse ?? ''
      const assistantMessages = chatbot.messages.filter(
        (message) => message.speaker === EMessageSpeaker.assistant,
      )

      // shouldActivateButton function checks for specific phrases in the AI response related to booking a meeting
      const shouldShowBookAMeeting = shouldActivateButton(
        aiResponse,
        assistantMessages,
      )
      // if the activateCalendly is true then set the showBookAMeeting to true and never change it back
      setChatbot({
        showBookAMeeting: shouldShowBookAMeeting,
        conversationId: response.data?.conversationId ?? '',
        messages: chatbot.messages.concat({
          speaker: EMessageSpeaker.assistant,
          message: response.data?.aiResponse ?? '',
        }),
      })
    },
  })
}

export default useChat
